import { ChatSessions } from '@/components/features/ChatSessions'

export function BeneficiaryChatRoute() {
  return <ChatSessions />
}
